import React, { useState, useEffect } from "react";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";
import { USERS_API_06, USERS_API_12 } from "../../api/ApiModel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import SearchAppBar from "../../components/common/search";
import { useNavigate } from "react-router-dom";
import ViewData from "../../components/grids/ViewDatagrid";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { userlogdata } from "../../assets/Griddata"; // Import dataset
import { useLocation } from "react-router-dom";

function ViewUserLogs({}) {
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState(null);

  const location = useLocation();
  const { userRefCode, username } = location.state || {};

  console.log("userRefCode", userRefCode);

  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [filteredRows, setFilteredRows] = useState([]);

  const gotToPage = () => {
    navigate("/ViewUsers");
  };

  // Utility function to format ENDATE
  const formatDate = (endDate) => {
    if (!endDate) return ""; // Handle empty or null values
    return new Date(endDate).toISOString().split("T")[0]; // Extract only the date part
  };

  const handleSearchChange = (event) => {
    // Update searchText when typing in TextField
  };

  useEffect(() => {
    setIsLoading(true);
    fetchUserLogData();
  }, []);

  const fetchUserLogData = async () => {
    try {
      const result = await externalgetApi(USERS_API_12, "get", {
        USERREFCODE: userRefCode || "",
      });
      // setData(result);

      // setFilteredRows(result);

      setData(result || []); // Ensure `data` is always an array
      setFilteredRows(result || []);
      console.log("result fetchUserLogData", result);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      //   onClick: (GROUPCODE) => handleItemClick(GROUPCODE, "Edit"),
    },
  ];

  const rows = (filteredData || data || []).map((item, index) => ({
    id: index + 1,
    REASON: item.REASON,
    ENUSER: item.ENUSER,
    LOCDATE: item.LOCDATE,
    ENDATE: formatDate(item.ENDATE), // Format ENDATE here
  }));

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Users</Link>
                <Link underline="none">User Logs</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack2,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToPage}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                  id="btnback"
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <ViewData
          columns={userlogdata?.columns || []}
          // columns={userlogdata.columns}
          rows={rows}
          // rows={filteredRows.map((item) => ({ ...item, id: item.USERREFCODE }))}
          // menuItems={menuItems}
          // tabletitle={userlogdata.name}
          tabletitle={`User Logs: ${username || "Unknown User"}`}
          gridid="USERREFCODE"
          displayActions={false}
        />
      )}
    </div>
  );
}

export default ViewUserLogs;
